// src/pages/settings/invoices/InvoiceSettingsTextsPage.tsx
import { Field } from '@chakra-ui/react'
import { useInvoiceSettingsCtx } from './InvoiceSettingsShell'
import MailEditor from '@/components/settings/MailEditor'
import { SettingsActionBar } from '@/pages/settings/SettingsActionBar' // adjust path
import { FormLayout } from '@/components/layout/FormLayout'

export function InvoiceSettingsTextsPage() {
  const {
    saving,
    serverErrors,
    clearServerError,
    autoFormik,
    hasAutoChanged,
    placeholders,
    saveAuto,
  } = useInvoiceSettingsCtx()

  return (
    <FormLayout.Root data-testid="invoice-settings-texts">
      <FormLayout.Section>
        <FormLayout.Title>Rechnungstexte</FormLayout.Title>
        <FormLayout.Description>
          Auf dieser Seite definieren Sie die individuellen Texte, die auf Ihren Rechnungen vor und
          nach der Positionsliste erscheinen. Dieser Schritt ist optional, Sie können die Felder
          auch leer lassen.
        </FormLayout.Description>
        <FormLayout.Description>
          Alle gesetzlich erforderlichen Pflichtangaben sowie die vollständige Rechnungstabelle
          werden automatisch eingefügt und sind unabhängig von Ihren hier definierten Vor- und
          Nachtexten.
        </FormLayout.Description>
      </FormLayout.Section>

      {/* Vortext */}
      <FormLayout.Section>
        <FormLayout.Title>Vortext definieren</FormLayout.Title>
        <FormLayout.Description>
          Dieser Text wird oberhalb der Rechnungspositionen angezeigt.
        </FormLayout.Description>

        <MailEditor
          value={autoFormik.values.invoicePreTextTemplate || ''}
          placeholders={placeholders}
          onChange={value => {
            autoFormik.setFieldValue('invoicePreTextTemplate', value)
            clearServerError('invoicePreTextTemplate')
          }}
        />

        {(serverErrors.invoicePreTextTemplate || autoFormik.errors.invoicePreTextTemplate) && (
          <Field.Root invalid>
            <Field.ErrorText mt={2}>
              {serverErrors.invoicePreTextTemplate ||
                (autoFormik.errors.invoicePreTextTemplate as any)}
            </Field.ErrorText>
          </Field.Root>
        )}
      </FormLayout.Section>

      {/* Nachtext */}
      <FormLayout.Section>
        <FormLayout.Title>Nachtext definieren</FormLayout.Title>
        <FormLayout.Description>
          Dieser Text erscheint unterhalb der Rechnungspositionen.
        </FormLayout.Description>

        <MailEditor
          value={autoFormik.values.invoicePostTextTemplate || ''}
          placeholders={placeholders}
          onChange={value => {
            autoFormik.setFieldValue('invoicePostTextTemplate', value)
            clearServerError('invoicePostTextTemplate')
          }}
        />

        {(serverErrors.invoicePostTextTemplate || autoFormik.errors.invoicePostTextTemplate) && (
          <Field.Root invalid>
            <Field.ErrorText mt={2}>
              {serverErrors.invoicePostTextTemplate ||
                (autoFormik.errors.invoicePostTextTemplate as any)}
            </Field.ErrorText>
          </Field.Root>
        )}
      </FormLayout.Section>

      {/* Action bar */}
      <SettingsActionBar
        visible={(autoFormik.dirty && hasAutoChanged) || saving}
        onCancel={() => autoFormik.resetForm()}
        onSave={saveAuto}
        saving={saving}
        saveDisabled={!autoFormik.dirty || !autoFormik.isValid || !hasAutoChanged || saving}
        cancelDisabled={saving}
      />
    </FormLayout.Root>
  )
}
